import React, { useState } from 'react';
import { templateService } from '../services/templateService';
import './TemplateButton.css';

const TemplateButton = ({ 
  label = 'Template Import',
  icon = 'fas fa-download',
  className = '',
  templateType = 'products',
  onSuccess,
  onError 
}) => {
  const [isDownloading, setIsDownloading] = useState(false);

  const handleDownload = async () => {
    setIsDownloading(true);

    try {
      console.log('🔄 Début téléchargement template...');

      const token = localStorage.getItem('token');
      if (!token) throw new Error('Token d\'authentification manquant');
      
      console.log('✅ Token présent:', token.substring(0, 20) + '...');

      // Appel du bon service selon le type
      const templateMethods = {
        products: () => templateService.downloadProductsTemplate(),
        categories: () => templateService.downloadCategoriesTemplate(),
        blogs: () => templateService.downloadBlogsTemplate(),
        quotes: () => templateService.downloadQuotesTemplate(),
        all: () => templateService.downloadAllTemplates(),
        default: () => templateService.downloadImportTemplate()
      };

      const selectedMethod = templateMethods[templateType] || templateMethods.default;
      const result = await selectedMethod();

      if (!result.success) {
        throw new Error(result.error || 'Erreur lors du téléchargement');
      }

      // Traiter le fichier blob
      const blob = new Blob([result.data], { 
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      });

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;

      // Extraire le nom de fichier depuis les headers ou utiliser un nom par défaut
      let fileName = `template_${templateType || 'import'}.xlsx`;
      if (result.response && result.response.headers) {
        const disposition = result.response.headers['content-disposition'];
        if (disposition && disposition.includes('filename=')) {
          fileName = disposition.split('filename=')[1].split(';')[0].replace(/['"]/g, '');
        }
      }

      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

      console.log('✅ Template téléchargé avec succès');
      if (onSuccess) onSuccess('Template téléchargé avec succès');

    } catch (error) {
      console.error('❌ Erreur téléchargement template:', error);

      let errorMessage = 'Erreur lors du téléchargement du template';
      if (error.response) {
        errorMessage = `Erreur ${error.response.status}: ${error.response.statusText}`;
      } else if (error.request) {
        errorMessage = 'Aucune réponse du serveur';
      } else {
        errorMessage = error.message;
      }

      if (onError) onError(errorMessage);
      else alert(errorMessage);
    } finally {
      setIsDownloading(false);
    }
  };

  return (
    <button
      className={`template-button ${className} ${isDownloading ? 'template-button--loading' : ''}`}
      onClick={handleDownload}
      disabled={isDownloading}
      type="button"
    >
      <i className={isDownloading ? 'fas fa-spinner fa-spin' : icon}></i>
      <span>{isDownloading ? 'Téléchargement...' : label}</span>
    </button>
  );
};

export default TemplateButton;
